const isRequiredIf = function(type, condition) {
  return function(props) {
    const test = condition(props) ? type.isRequired : type;
    return test.apply(this, arguments);
  };
};
module.exports = isRequiredIf;



// WEBPACK FOOTER //
// ./src/components/modules/react-conditional-required/index.js